import React from 'react';
import styled from '@emotion/styled';
import { Button } from '@qga/roo-ui/components';
import { mediaQuery } from 'lib/styledSystem';
import { useRouter } from 'next/router';
import useCtaClickEvent from 'hooks/useCtaClickEvent';

const StyledButton = styled(Button)`
  font-size: 1rem;
  line-height: 12px;
  font-weight: 500;
  height: 46px;
  ${mediaQuery.minWidth.sm} {
    padding: 0 12px 0 12px;
    top: 0px;
    position: relative;
  }
`;

const CheckAvailabilityButton = () => {
  const router = useRouter();
  const { ctaClickEvent } = useCtaClickEvent();
  const onCheckAvailabilityClicked = () => {
    ctaClickEvent({ itemText: 'Check Availability', itemType: 'button', url: '#check-availability' });
    router.replace(
      {
        hash: 'check-availability',
        query: { ...router.query },
      },
      undefined,
      { shallow: true, scroll: false },
    );
  };
  return (
    <StyledButton
      variant="primary"
      ml={['6%', 0, 0]}
      mr={[0, 2, 0]}
      mt={[3, 3, 3]}
      width={['88%', '40%', '22%', '22%']}
      onClick={onCheckAvailabilityClicked}
      data-testid="check-availability-cta"
      aria-label={`check availability`}
    >
      Check Availability
    </StyledButton>
  );
};

export default CheckAvailabilityButton;
